import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    viewBox="0 0 64 64"
    ref={svgRef}
    {...props}
  >
    <mask
      id="rocket_svg__a"
      style={{
        maskType: "alpha",
      }}
      width={64}
      height={64}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
    >
      <path fill="currentColor" d="M0 0h64v64H0z" />
    </mask>
    <g mask="url(#rocket_svg__a)">
      <path
        fill="currentColor"
        d="M17.533 33a48.731 48.731 0 014.3-8.7 57.638 57.638 0 015.834-7.767l-5.134-1a5.29 5.29 0 00-2.633.134A5.317 5.317 0 0017.667 17L8.6 26.133c-.489.49-.667 1.078-.533 1.767.133.689.51 1.167 1.133 1.433L17.533 33zM56.2 6.467c-4.844-.356-9.433.477-13.767 2.5-4.333 2.022-8.233 4.766-11.7 8.233a49.274 49.274 0 00-5.9 7.1 38.929 38.929 0 00-4.233 8.167 3.566 3.566 0 00-.267 1.333c0 .444.178.844.534 1.2l9 9c.355.355.755.533 1.2.533a3.58 3.58 0 001.333-.266 35.916 35.916 0 008.167-4.2 51.034 51.034 0 007.1-5.934c3.466-3.466 6.222-7.366 8.266-11.7 2.045-4.333 2.89-8.922 2.534-13.766a3.06 3.06 0 00-.234-.767 2.403 2.403 0 00-.5-.7 2.403 2.403 0 00-.7-.5 3.049 3.049 0 00-.833-.233zM39.067 25.8c-.89-.889-1.334-1.989-1.334-3.3 0-1.311.445-2.411 1.334-3.3.889-.889 1.989-1.333 3.3-1.333 1.31 0 2.41.444 3.3 1.333.889.889 1.333 1.989 1.333 3.3 0 1.311-.444 2.411-1.333 3.3-.89.889-1.99 1.333-3.3 1.333-1.311 0-2.411-.444-3.3-1.333zm-7.134 21.533l3.6 8.334c.267.666.756 1.055 1.467 1.166.711.111 1.311-.078 1.8-.566l9.067-9.067a5.319 5.319 0 001.333-2.233 5.292 5.292 0 00.133-2.634L48.4 37.2a57.638 57.638 0 01-7.767 5.833 48.731 48.731 0 01-8.7 4.3zM10.8 42.8c1.556-1.556 3.444-2.344 5.667-2.367 2.222-.022 4.11.745 5.666 2.3 1.556 1.556 2.334 3.445 2.334 5.667s-.778 4.111-2.334 5.667c-2.133 2.133-4.655 3.4-7.566 3.8-2.911.4-5.834.8-8.767 1.2.4-2.934.811-5.856 1.233-8.767.423-2.911 1.678-5.411 3.767-7.5z"
      />
    </g>
  </Icon>
));
